// Context + hook cho theme DiOwner. Giữ { mode, primaryColorKey, density }, persist
// localStorage, và áp lên DOM (data-theme + data-density + biến --brand...) mỗi khi đổi.
import {
  createContext,
  useContext,
  useCallback,
  useMemo,
  useState,
  useLayoutEffect,
} from 'react';

import {
  applyTheme,
  saveTheme,
  getInitialTheme,
  THEME_MODES,
  DENSITIES,
} from '@app/theme';

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState(getInitialTheme);

  // Áp trước khi paint để tránh nháy màu (flash-of-wrong-theme).
  useLayoutEffect(() => {
    applyTheme(theme);
    saveTheme(theme);
  }, [theme]);

  const setMode = useCallback((mode) => {
    if (!THEME_MODES.includes(mode)) return;
    setThemeState((prev) => ({ ...prev, mode }));
  }, []);

  const toggleMode = useCallback(() => {
    setThemeState((prev) => ({
      ...prev,
      mode: prev.mode === 'dark' ? 'light' : 'dark',
    }));
  }, []);

  const setPrimaryColorKey = useCallback((primaryColorKey) => {
    setThemeState((prev) => ({ ...prev, primaryColorKey }));
  }, []);

  const setDensity = useCallback((density) => {
    if (!DENSITIES.includes(density)) return;
    setThemeState((prev) => ({ ...prev, density }));
  }, []);

  const value = useMemo(
    () => ({
      mode: theme.mode,
      primaryColorKey: theme.primaryColorKey,
      density: theme.density,
      setMode,
      toggleMode,
      setPrimaryColorKey,
      setDensity,
    }),
    [
      theme.mode,
      theme.primaryColorKey,
      theme.density,
      setMode,
      toggleMode,
      setPrimaryColorKey,
      setDensity,
    ]
  );

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const ctx = useContext(ThemeContext);
  if (!ctx) {
    throw new Error('useTheme phải dùng bên trong <ThemeProvider>');
  }
  return ctx;
};
